// Which payment gateway a top-up uses, and how a Toman price becomes the
// number that gateway expects.
//
// THE WHOLE UI PRICES IN TOMAN. The gateways disagree about the unit they
// settle in — Sepehr (بانک صادرات / شاپرک) takes RIALS, Zarinpal takes Toman —
// so the conversion happens exactly once, here, at the moment an amount is
// handed to the BFF. The BFF passes the figure through untouched, precisely so
// there is only one place that can multiply by ten.

// The table is DATA — `rialsPerToman` decides what a payment is worth, and
// `toGatewayAmount` must not need a translator to compute it. Only the bank's
// display name is copy, so only that is a key.
export const GATEWAYS = {
  sepehr: { labelKey: 'credits.gateway.saderat', unit: 'IRR', rialsPerToman: 10 },
  zarinpal: { labelKey: 'credits.gateway.zarinpal', unit: 'IRT', rialsPerToman: 1 },
};

/** The gateway new top-ups go through. Matches the doctor panel's. */
export const PAYMENT_GATEWAY = 'sepehr';

/** The gateway's name, for the pay button. */
export const gatewayLabel = (t, gateway = PAYMENT_GATEWAY) => {
  const key = GATEWAYS[gateway]?.labelKey;
  return key ? t(key) : '';
};

/** Convert a Toman price into the amount the given gateway expects. */
export function toGatewayAmount(amountToman, gateway = PAYMENT_GATEWAY) {
  const factor = GATEWAYS[gateway]?.rialsPerToman ?? 1;
  return Math.round(amountToman * factor);
}
